var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.861146 1.29357C1.04867 1.1061 1.30298 1.00078 1.56815 1.00078C1.83331 1.00078 2.08762 1.1061 2.27515 1.29357L5.56815 4.58657L8.86115 1.29357C8.95339 1.19806 9.06374 1.12188 9.18574 1.06947C9.30774 1.01706 9.43897 0.989473 9.57174 0.988319C9.70452 0.987165 9.8362 1.01247 9.9591 1.06275C10.082 1.11303 10.1936 1.18728 10.2875 1.28117C10.3814 1.37507 10.4557 1.48672 10.506 1.60962C10.5562 1.73251 10.5816 1.86419 10.5804 1.99697C10.5792 2.12975 10.5517 2.26097 10.4992 2.38297C10.4468 2.50498 10.3707 2.61532 10.2751 2.70757L6.27515 6.70757C6.08762 6.89504 5.83331 7.00036 5.56815 7.00036C5.30298 7.00036 5.04867 6.89504 4.86115 6.70757L0.861146 2.70757C0.673675 2.52004 0.568359 2.26573 0.568359 2.00057C0.568359 1.73541 0.673675 1.4811 0.861146 1.29357Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.e91362ae8af75659b7342eab806d98cf.svg";
export { ForwardRef as ReactComponent };